import axios from "axios";

export const urlBase = process.env.REACT_APP_API_URL;

const urlResource = `${urlBase}/chatbot-resource-management-api/v1.0`

const authHeaders = {
  'x-api-key': 'vietrade-ai',
};

const getAllNote= async (conversationId) => {
  try {
    const response = await axios.get(`${urlResource}/chatbot-web-note/`, {
      headers: {
        'x-api-key': 'vietrade-ai',
      },
      params: {
        conversationId
      },
    });

    return response.data;
  } catch (error) {
    console.error('getAllDocument error:', error);
    throw error;
  }
};

const createNote = async ({conversationId, visitorId, title, content}) => {
    try {
        const response = await axios.post(`${urlResource}/chatbot-web-note/`, 
            {
                conversationId,
                userId: visitorId,
                content: content,
                title: title,
            },
            {
                headers: {
                    'x-api-key': 'vietrade-ai'
                }
            })
        return response.data;
    } catch (error) {
        console.error('createNote error:', error);
        throw error;
    }
}

const getNoteDetail = async (conversationId, noteId) => {
  try {
    const response = await axios.get(`${urlResource}/chatbot-web-note/${noteId}`, {
      headers: {
        'x-api-key': 'vietrade-ai',
      },
      params: {
        conversationId,
      },
    });

    return response.data;
  } catch (error) {
    console.error('getNoteDetail error:', error);
    throw error;
  }
};

const editNote = async (id, updateNote) => {
    try {
        const response = await axios.patch(`${urlResource}/chatbot-web-note/${id}`, updateNote, {
            headers: {
                'x-api-key': 'vietrade-ai'
            }
        })
        return response.data;
    } catch (error) {
        console.error('editNote error:', error);
        throw error;
    }

}

const deleteNote = async (conversationId, noteId) => {
    try {
        const response = await axios.delete(`${urlResource}/chatbot-web-note`, {
            data:{
                conversationId,
                ids: [noteId]
            },
            headers: {
                'x-api-key': 'vietrade-ai'
            }
        })
        return response.data;
    } catch (error) {
        console.error('deleteNote error:', error);
        throw error;
    }
}

const NoteAPI = {
    getAllNote,
    createNote,
    getNoteDetail,
    editNote,
    deleteNote
}

export default NoteAPI